// If a user has been cached with the data, verify if
// the user is the same as the one requesting the data.
const isValidUser = (userCached?: string, userRequesting?: string): boolean => {
  if (!userCached) return true;
  if (userCached === userRequesting) return true;

  return false;
};

const getLocalStorageItem = <StoredDataType>(
  cacheKey: string,
  time: number,
  userRequesting?: string
): StoredDataType | null => {
  try {
    const cacheData = JSON.parse(localStorage.getItem(cacheKey));
    if (cacheData) {
      const timeElapsed = Date.now() - cacheData.timestamp;
      const userCached = cacheData.user;

      // Check if the time elapsed is less than the specified time (in milliseconds).
      // And if a user has been cached, verify that the user requesting the data is the same.
      if (timeElapsed < time && isValidUser(userCached, userRequesting)) {
        return cacheData.data;
      }

      // Remove the cached data from localStorage if the specified time has elapsed
      localStorage.removeItem(cacheKey);
      // Return null because the cached data is no longer valid
      return null;
    }
  } catch {
    // Catch disabled local storage error that occurred during the try block and return null
    return null;
  }
};

const setLocalStorageItem = <DataToStoreType>(
  cacheKey: string,
  data: DataToStoreType,
  user?: string
): void => {
  try {
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        data,
        timestamp: Date.now(),
        user,
      })
    );
  } catch (error) {
    // If max quota has been reached, clear all the local storage
    if (error?.name === 'QuotaExceededError') {
      localStorage.clear();
    }
  }
};

export { getLocalStorageItem, setLocalStorageItem, isValidUser };
